import { Grid } from "@material-ui/core";
import {
	InputReactDatepicker,
	InputTextMaster,
	LabelRequired,
	MasterButton,
	Modal,
} from "App/Component/ui";
import {
	defaultToastError,
	defaultToastSuccess,
	isNull,
} from "App/utils/helpers";
import React, { useContext, useEffect, useState } from "react";
import { BundleCtx } from "../context/context";
import useReloadTableBundle from "./hooks/useReloadTableBundle";
import BundleHeaderTable from "./BundleHeaderTable";
import {
	BUTTON_SUBMIT,
	RESET_STATE_DETAIL,
	RESET_STATE_HEADER,
	postBundleHeader,
} from "./helpers";

function BundleHeader({
	showModal,
	setShowModal,
	formDataBundle,
	setFormDataBundle,
}) {
	const { state } = useContext(BundleCtx);
	const rows = state.bundle.data;
	const totalData = state.bundle.count;

	const [disabled, setDisabled] = useState(BUTTON_SUBMIT);

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		handleChange,
		loading,
		formFilter,
		setFormFilter,
	} = useReloadTableBundle();

	const handleSearch = async (e) => {
		e.preventDefault();

		if (!isNull(formFilter.tglAwal) && !isNull(formFilter.tglAkhir)) {
			setNewData(1, 10, {
				tglAwal: formFilter.tglAwal,
				tglAkhir: formFilter.tglAkhir,
			});
		}
	};

	useEffect(() => {
		setNewData(1, 10, {
			tglAwal: formFilter.tglAwal,
			tglAkhir: formFilter.tglAkhir,
		});
	}, []);

	const handleSelect = (rows) => {
		setFormDataBundle({
			id_bundle: rows.id_bundle,
		});
		setShowModal(!showModal);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (isNull(formFilter.keterangan)) {
			defaultToastError("Nama Bundle Belum Di Isi");
			return false;
		}

		const response = await postBundleHeader(formFilter.keterangan);

		if (!response.state) {
			setDisabled(BUTTON_SUBMIT);
			defaultToastSuccess(response.message);
			setNewData(1, 10, {});
			setFormDataBundle({
				...RESET_STATE_DETAIL,
				id_bundle: response.data.id_bundle,
			});
			setFormFilter(RESET_STATE_HEADER);
		} else {
			setDisabled(BUTTON_SUBMIT);
			defaultToastError(response.message);
		}
	};

	return (
		<>
			<Modal title={`Semua Bundle`} width="80%" show={setShowModal}>
				<div className="mb-1">
					<Grid container spacing={1}>
						<Grid item sm={12}>
							<InputTextMaster
								name="keterangan"
								label={<LabelRequired label="NAMA BUNDLE" />}
								id="keterangan"
								placeholder="NAMA BUNDLE"
								value={formFilter.keterangan}
								onChange={handleChange("keterangan")}
							/>
						</Grid>
					</Grid>
					<Grid
						container
						direction="row"
						justifyContent="flex-end"
						alignItems="center"
					>
						<MasterButton
							className={"mt-1"}
							type="button"
							onClick={(e) => handleSubmit(e)}
							color={disabled.color}
							name={disabled.label}
							disabled={disabled.disabled}
							size="md"
						/>
					</Grid>
				</div>
				<Grid container spacing={1}>
					<Grid item sm={6}>
						<InputReactDatepicker
							selected={formFilter.tglAwal}
							label="TANGGAL MULAI"
							handleChangeToday={(e) =>
								setFormFilter({
									...formFilter,
									tglAwal: e,
								})
							}
							onChange={(e) =>
								setFormFilter({
									...formFilter,
									tglAwal: e,
								})
							}
						/>
					</Grid>
					<Grid item sm={6}>
						<InputReactDatepicker
							selected={formFilter.tglAkhir}
							label="TANGGAL SELESAI"
							handleChangeToday={(e) =>
								setFormFilter({
									...formFilter,
									tglAkhir: e,
								})
							}
							onChange={(e) =>
								setFormFilter({
									...formFilter,
									tglAkhir: e,
								})
							}
						/>
					</Grid>
				</Grid>
				<Grid
					container
					direction="row"
					justifyContent="flex-end"
					alignItems="center"
				>
					<MasterButton
						className={"mt-1"}
						type="button"
						onClick={(e) => handleSearch(e)}
						color={"lightgreen"}
						name={"CARI"}
						size="md"
					/>
				</Grid>

				<div className="mt-1">
					<BundleHeaderTable
						rows={rows}
						handleSelect={handleSelect}
						totalData={totalData}
						resetPagination={resetPagination}
						setNewData={setNewData}
						pagination={pagination}
						onPrevious={onPrevious}
						onNext={onNext}
						handleClickPageNumber={handleClickPageNumber}
						handleChangeLimit={handleChangeLimit}
						loading={loading}
						formFilter={formFilter}
						setFormFilter={setFormFilter}
					/>
				</div>
			</Modal>
		</>
	);
}

export default BundleHeader;
